import React from "react";
import './Button.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Button = ({ label, onClick, variant="default" , style, disabled ,icon }) => {
  // Bootstrap button classes based on props
  const buttonClass = `btn btn-${variant}`;

  return (
    
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {label}
       {/* Render icon only if provided */}
       {icon && <FontAwesomeIcon icon={icon} style={{  marginLeft: label ? "8px" : "0" }} />}

    </button>
    
  );
};

export default Button;